export default {
  zhTW: "Chinese(Traditional)",
  enUS: "English",
};
